export default {
    xxs: '6px',
    xs: '8px',
    s: '10px',
    m: '12px',
    l: '14px',
    xl: '16px',
    xxl: '18px',
    sectionTitle: '120px',
    sectionTitleMobile: '20vw',
    sectionTitleTablet: '18vw',
    sectionTitleDesktop: '15vw'
};  